export const config = {
    snackBarTimeOut : 5000,
    timeZoneRegEx: /([A-Z]+[+-][0-9]+)/,

    /* All the special character that have a special meaning in the Regular Expression */
    specialChar : /([.*+?^=!:${}()|[\]/\\])/g,

    /**This property is to store the name of the third party notices file created using BD*/
    thirdPartyNoticesLocation : "assets/bdscan-3rdpartynotices.txt"
}
